import type { ComponentType } from 'react'
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '@/theme/deco.css'
import { ToastProvider } from '@/ui'

// The negative pattern keeps *.test.tsx out of the production bundle — a plain
// glob pulls every sibling test file (and its mocks) into the shipped assets.
const pages = import.meta.glob<{ default: ComponentType }>([
  '../pages/**/*.tsx',
  '!../pages/**/*.test.tsx',
])

createInertiaApp({
  resolve: (name) => pages[`../pages/${name}.tsx`]!().then((mod) => mod.default),
  setup({ el, App, props }) {
    if (!el) return
    createRoot(el).render(
      <ToastProvider>
        <App {...props} />
      </ToastProvider>,
    )
  },
})
